import React from 'react';
import ColumnContainer from './ColumnContainer';
import { ColumnContext } from '../context';
import ModalBox from './ModalBox';

export default class Board extends React.Component {
    static contextType = ColumnContext;

    render() {
        const {
            columns,
            setColumns,
            tasks,
            moveTaskUp,
            moveTaskToColumn,
            addTaskToColumn,
            updateColunTitleInLocalStorage,
            updateDeadlineDateInLocalStorage,
            isModalOpen,
            handleCloseModal,
            handleAddColumn,
            columnAddStatus,
            setColumnAddStatus,
            getTaskMailIndbox,
            filterList,
            handleUpdateTask,
            setSelectedBoardId,
            selectedBoardId,
            moveColumn,
            taskMail,
            setTaskMail,
            getTaskMail,
            setSortBy,
            setSortOrder,
            sortby,
            sortOrder,
            getAllBoard,
            activeButton,
            columnAutomation,
            allCustomFieldList,
            setAllCustomFieldList,
            getAllAutomation
        } = this.context;
        const {
            boardName,
            isMember,
            parentOrigin
        } = this.props;
        return (
            <div className="w-full h-screen">
                <section className="kanban overflow-x-auto overflow-y-hidden min-w-full">
                    <ColumnContainer
                        columns={columns}
                        setColumns={setColumns}
                        tasks={tasks}
                        moveTaskToColumn={moveTaskUp}
                        removeTask={updateColunTitleInLocalStorage}
                        addTaskToColumn={addTaskToColumn}
                        handleAddColumn={handleAddColumn}
                        columnAddStatus={columnAddStatus}
                        setColumnAddStatus={setColumnAddStatus}
                        getTaskMailIndbox={getTaskMailIndbox}
                        filterList={filterList}
                        handleUpdateTask={handleUpdateTask}
                        selectedBoardId={selectedBoardId}
                        moveColumn={moveColumn}
                        taskMail={taskMail}
                        setTaskMail={setTaskMail}
                        getTaskMail={getTaskMail}
                        setSortBy={setSortBy}
                        setSortOrder={setSortOrder}
                        sortby={sortby}
                        sortOrder={sortOrder}
                        getAllBoard={getAllBoard}
                        activeButton={activeButton}
                        setSelectedBoardId={setSelectedBoardId}
                        boardName={boardName}
                        isMember={isMember}
                        parentOrigin={parentOrigin}
                        columnAutomation={columnAutomation}
                        setAllCustomFieldList={setAllCustomFieldList}
                        allCustomFieldList={allCustomFieldList}
                        getAllAutomation={getAllAutomation}
                        userList={this.context.userList}
                    />
                </section>
                {isModalOpen && <ModalBox onClose={handleCloseModal} isModalOpen={isModalOpen} />}
            </div>
        );
    }
}
